import NotFoundTemplate from 'src/templates/NotFoundTemplate'
import { useTranslation } from 'react-i18next'
import Router from 'src/routes/Router'
import { useRouter } from 'next/router'
import routes from 'src/routes/definitions'
import { FC } from 'react'
import { GetStaticPropsContext } from 'next'
import getTranslations from 'src/rest/requests/translations/getTranslations'
import RestApiClient from 'src/rest/client'
import { initWithLangAndLabels } from 'src/i18n'

const NotFoundPage: FC<any> = () => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <NotFoundTemplate
      title={t('notFound.title')}
      text={t('notFound.text')}
      button={{
        text: t('notFound.button'),
        href: Router.getRouteUrl(routes.home),
        locale: router.locale ?? 'fr',
      }}
    />
  )
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const locale = context?.locale ?? 'fr'

  const [translationsRs] = await Promise.all([
    RestApiClient.call(getTranslations({ locale })),
  ])

  const data = translationsRs?.data ?? null
  const i18n = initWithLangAndLabels(locale, data ?? {})

  return {
    props: {
      data,
      i18n,
      locale,
    },
  }
}

export default NotFoundPage
